import { render, staticRenderFns } from "./download-pdf.vue?vue&type=template&id=dc84b62a&scoped=true&"
import script from "./download-pdf.vue?vue&type=script&lang=js&"
export * from "./download-pdf.vue?vue&type=script&lang=js&"
import style0 from "./download-pdf.vue?vue&type=style&index=0&id=dc84b62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc84b62a",
  null
  
)

export default component.exports